module.exports = __webpack_public_path__ + "static/img/link-candidaturas.6a0422a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/link-candidaturas.jpg
// module id = VPXK
// module chunks = 1